module.exports = __webpack_public_path__ + "img/bank-22-sanrim.530aff71.svg";